module.exports = __webpack_public_path__ + "static/media/progman_10.1ed0fa28.ico";